import { utcToZonedTime } from "@gymflow/helpers";
import { EventOccurrenceDTO } from "@gymflow/types";
import merge from "lodash/merge";

export function eventOccurrenceToZonedTime(
  occurrence: EventOccurrenceDTO,
  timezone: string,
) {
  const eventStart = utcToZonedTime(
    `${occurrence.event.startDate}T${occurrence.event.startTime}Z`,
    timezone,
  );
  const [eventStartDate, eventStartTime] = eventStart.split("T");
  const eventEnd = utcToZonedTime(
    `${occurrence.event.endDate}T${occurrence.event.endTime}Z`,
    timezone,
  );
  const [eventEndDate, eventEndTime] = eventEnd.split("T");
  const eventInUtc = {
    startDate: eventStartDate,
    startTime: eventStartTime,
    endDate: eventEndDate,
    endTime: eventEndTime,
  } as any;

  if (occurrence.event.startRecurringDate) {
    const recurringStart = utcToZonedTime(
      `${occurrence.event.startRecurringDate}T${occurrence.event.startTime}Z`,
      timezone,
    );
    const [recurringStartDate] = recurringStart.split("T");
    eventInUtc.startRecurringDate = recurringStartDate;
  }

  if (occurrence.event.endRecurringDate) {
    const recurringEnd = utcToZonedTime(
      `${occurrence.event.endRecurringDate}T${occurrence.event.endTime}Z`,
      timezone,
    );
    const [recurringEndDate] = recurringEnd.split("T");
    eventInUtc.endRecurringDate = recurringEndDate;
  }

  return merge({}, occurrence, {
    event: eventInUtc,
    startDate: utcToZonedTime(occurrence.startDate, timezone),
    endDate: utcToZonedTime(occurrence.endDate, timezone),
  });
}
